import { CustomToast, CustomToastProps } from './CustomToast';
import { toast } from 'react-hot-toast';
import { DURATION } from './constants';
import { getErrorMessage } from '../../utils/error';

interface ToastProps extends Omit<CustomToastProps, 'handleClose'> {
  duration?: number;
}
export const generateToast = (props: ToastProps) => {
  const handleClose = (id?: string) => toast.remove(id);
  return toast.custom((t) => <CustomToast {...props} currentToast={t} handleClose={handleClose} />, {
    duration: props.duration || DURATION.DEFAULT,
  });
};

export const generateErrorToast = ({ message, title }: { message: string; title?: string }) => {
  return generateToast({
    color: 'danger',
    title,
    message,
  });
};

export const toastFromError = ({ error, title }: { error: unknown; title: string }) => {
  return generateErrorToast({
    title,
    message: getErrorMessage(error),
  });
};
